var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center py-3"},[_c('div',{staticClass:"flex-none w-12"},[(_vm.hasImage)?_c('img',{attrs:{"src":_vm.logoUrl}}):_vm._e()]),_c('div',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }